module.exports = __webpack_public_path__ + "img/edit-icon.6ccb34f2.svg";